export default __webpack_public_path__ + "static/media/1520.f5742c1c.png";